import { ROLE_AGENT, ROLE_CLIENT, ROLE_MANAGER } from '@/consts/app'
import routesEvents from '@/router/terrain/routesEvents'
import SimpleRouteWrapper from '@/router/SimpleRouteWrapper'
import {
  ACCOUNT_RIGHT_CREATE_CHECKPOINT,
  ACCOUNT_RIGHT_CREATE_MISSION,
  ACCOUNT_RIGHT_CREATE_ROUND,
  ACCOUNT_RIGHT_CREATE_SELF_REQUEST,
  ACCOUNT_RIGHT_EDIT_ROUND,
  ACCOUNT_RIGHT_LIST_CHECKPOINTS,
  ACCOUNT_RIGHT_LIST_MISSION_EVENTS,
  ACCOUNT_RIGHT_LIST_MISSIONS,
  ACCOUNT_RIGHT_LIST_REQUESTS,
  ACCOUNT_RIGHT_LIST_ROUNDS
} from '@/consts/rights'
import { routeBadgeRequestUnread } from '@/utils/routing'
// Pages
const PriseService = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/PriseService')
const Intervention = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/DashBoard/ServicesNonPlanifies/Intervention')
const Tournee = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/DashBoard/ServicesNonPlanifies/Tournee')
const ServiceActif = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/ServiceActif')
const CircuitActif = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/CircuitActif')
const Events = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/Events/Events')
const Nfc = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/Nfc')
const Alertes = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/Alertes')
const ServicesPlanifies = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/DashBoard/ServicesPlanifies')
const Planning = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/Planning')
const RondesListing = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/Rondes/RondesListing')
const RondeEdit = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/Rondes/RondeEdit')
const RondeEditCheckpoints = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/Rondes/RondeEditCheckpoints')
const RondeSecurite = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/Events/RondeSecurite')
const CheckPointsListing = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/CheckPoints/CheckPointsListing')
const CheckPointEdit = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/CheckPoints/CheckPointEdit')
const AgentsAnnuaire = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/Agents/AgentsAnnuaire')
const ServicesNonPlanifies = () => import(/* webpackChunkName: "app-terrain" */'pages/Terrain/DashBoard/ServicesNonPlanifies')
const Demandes = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Demandes')
const Documents = () => import(/* webpackChunkName: "app-platform" */'pages/Platform/Documents')

export const ROUTE_NAME_TERRAIN_DASHBOARD = 'terrainDashboard'
export const ROUTE_NAME_TERRAIN_PLANNING = 'terrainPlanning'
export const ROUTE_NAME_TERRAIN_PRISE_SERVICE = 'terrainPriseService'
export const ROUTE_NAME_TERRAIN_SERVICE_ACTIF = 'terrainServiceActif'
export const ROUTE_NAME_TERRAIN_CIRCUIT_ACTIF = 'terrainCircuitActif'
export const ROUTE_NAME_TERRAIN_SERVICE_NON_PLANIFIE = 'terrainServicesNonPlanifies'
export const ROUTE_NAME_TERRAIN_RONDE_SECU = 'terrainEventsRonde'
export default [
  // {
  //   path: 'terrain/dashboard',
  //   name: ROUTE_NAME_TERRAIN_DASHBOARD,
  //   component: DashBoard,
  //   meta: {
  //     label: 'Tableau de bord',
  //     icon: 'fa fa-home',
  //     roles: [ROLE_MANAGER],
  //     mode: ['terrain']
  //   },
  //   redirect: { name: 'terrainServicesPlanifies' },
  //   children: routesDashboard
  // },
  {
    path: 'terrain/priseService/:reference?',
    name: ROUTE_NAME_TERRAIN_PRISE_SERVICE,
    props: true,
    component: PriseService
  },
  {
    path: 'terrain/intervention/:id?',
    name: 'terrainIntervention',
    props: true,
    component: Intervention
  },
  {
    path: 'terrain/tournee/:id?',
    name: 'terrainTournee',
    props: true,
    component: Tournee
  },
  {
    path: 'terrain/serviceActif/:slug?',
    name: ROUTE_NAME_TERRAIN_SERVICE_ACTIF,
    props: true,
    component: ServiceActif
  },
  {
    path: 'terrain/circuitActif/:slug?',
    name: ROUTE_NAME_TERRAIN_CIRCUIT_ACTIF,
    props: true,
    component: CircuitActif
  },
  {
    path: 'terrain/events',
    name: 'terrainEvents',
    component: Events,
    redirect: '/',
    children: routesEvents
  },
  {
    path: 'terrain/planning',
    name: ROUTE_NAME_TERRAIN_PLANNING,
    component: Planning,
    meta: {
      label: 'Mon planning',
      icon: 'fa fa-calendar-day',
      roles: [ROLE_AGENT, ROLE_CLIENT],
      mode: ['terrain']
    }
  },
  {
    path: 'servicesNonPlanifies',
    name: ROUTE_NAME_TERRAIN_SERVICE_NON_PLANIFIE,
    component: ServicesNonPlanifies,
    meta: {
      label: 'Service non planifié',
      icon: 'fa fa-user-shield',
      roles: [ROLE_AGENT],
      mode: ['terrain'],
      isGranted: [ACCOUNT_RIGHT_CREATE_MISSION]
    }
  },
  {
    path: 'demandes',
    name: 'terrainAgentRequests',
    component: Demandes,
    meta: {
      label: 'Demandes',
      icon: 'fa fa-comment-dots',
      roles: [ROLE_MANAGER, ROLE_AGENT],
      badge: routeBadgeRequestUnread,
      mode: ['terrain'],
      isGranted: [
        ACCOUNT_RIGHT_CREATE_SELF_REQUEST,
        ACCOUNT_RIGHT_LIST_REQUESTS
      ]
    }
  },
  {
    path: 'documents',
    name: 'terrainAgentDocuments',
    component: Documents,
    meta: {
      label: 'Documents',
      icon: 'fas fa-clipboard',
      roles: [ROLE_AGENT],
      mode: ['terrain']
    }
  },
  {
    path: 'agentEvents',
    name: 'terrainAgentEvents',
    component: Alertes,
    meta: {
      label: 'Événements',
      icon: 'fa fa-bullhorn',
      roles: [ROLE_AGENT],
      isGranted: [
        ACCOUNT_RIGHT_LIST_MISSION_EVENTS
      ]
    }
  },
  {
    path: 'terrain/nfc',
    name: 'terrainNfc',
    component: Nfc,
    meta: {
      label: 'Lire un badge',
      icon: 'fa fa-qrcode',
      roles: [ROLE_AGENT],
      mode: ['terrain']
    }
  },
  {
    path: 'terrain/adminDashboard',
    name: 'terrainAdminDashboard',
    component: SimpleRouteWrapper,
    meta: {
      label: 'Tableau de bord',
      group: true,
      roles: [ROLE_MANAGER],
      icon: 'fa fa-tachometer-alt',
      mode: ['terrain']
    },
    children: [
      {
        path: 'adminAlerts',
        name: 'terrainAdminAlerts',
        component: Alertes
      },
      {
        path: 'adminEvents',
        name: 'terrainAdminEvents',
        component: Alertes,
        meta: {
          label: 'Événements',
          icon: 'fa fa-bullhorn',
          isGranted: [
            ACCOUNT_RIGHT_LIST_MISSION_EVENTS
          ]
        }
      },
      {
        path: 'adminServices',
        name: 'terrainAdminServices',
        component: ServicesPlanifies,
        meta: {
          label: 'Services',
          icon: 'fa fa-clipboard-list',
          isGranted: [
            ACCOUNT_RIGHT_LIST_MISSIONS
          ]
        }
      },
      {
        path: 'adminPlanning',
        name: 'terrainAdminPlanning',
        component: Planning,
        meta: {
          label: 'Planning',
          icon: 'fa fa-calendar-day',
          isGranted: [
            ACCOUNT_RIGHT_LIST_MISSIONS
          ]
        }
      }
    ]
  },
  {
    path: 'terrain/rondes',
    name: 'terrainRondes',
    component: SimpleRouteWrapper,
    meta: {
      label: 'Rondes',
      group: true,
      roles: [ROLE_MANAGER, ROLE_AGENT],
      mode: ['terrain']
    },
    redirect: { name: 'terrainRondesList' },
    children: [
      {
        path: 'list',
        name: 'terrainRondesList',
        component: RondesListing,
        meta: {
          label: 'Liste',
          icon: 'fa fa-list',
          isGranted: [
            ACCOUNT_RIGHT_LIST_ROUNDS // Liste rondes
          ]
        }
      },
      {
        path: 'edit/:slug?',
        name: 'terrainRondesEdit',
        component: RondeEdit,
        props: true,
        meta: {
          label: 'Créer',
          icon: 'fa fa-plus',
          isGranted: [
            ACCOUNT_RIGHT_CREATE_ROUND // Création rondes
          ]
        }
      },
      {
        path: 'editCheckpoints/:slug',
        name: 'terrainRondesEditCheckpoints',
        component: RondeEditCheckpoints,
        props: true,
        meta: {
          isGranted: [
            ACCOUNT_RIGHT_EDIT_ROUND // Modifiation rondes
          ]
        }
      }
    ]
  },
  {
    path: 'ronde/:reference?/:iteration?',
    name: ROUTE_NAME_TERRAIN_RONDE_SECU,
    component: RondeSecurite,
    props: true
    // meta: {
    //   label: 'Ronde de sécurité'
    // }
  },
  {
    path: 'terrain/checkpoints',
    name: 'terrainCheckpoints',
    component: SimpleRouteWrapper,
    meta: {
      label: 'Points de contrôle',
      group: true,
      roles: [ROLE_MANAGER, ROLE_AGENT],
      mode: ['terrain']
    },
    redirect: { name: 'terrainCheckpointsList' },
    children: [
      {
        path: 'list',
        name: 'terrainCheckpointsList',
        component: CheckPointsListing,
        meta: {
          label: 'Liste',
          icon: 'fa fa-list',
          isGranted: [
            ACCOUNT_RIGHT_LIST_CHECKPOINTS // Liste checkpoint
          ]
        }
      },
      {
        path: 'edit/:slug?',
        name: 'terrainCheckpointsEdit',
        component: CheckPointEdit,
        props: true,
        meta: {
          label: 'Créer',
          icon: 'fa fa-plus',
          isGranted: [
            ACCOUNT_RIGHT_CREATE_CHECKPOINT // Création checkpoint
          ]
        }
      }
    ]
  },
  {
    path: 'terrain/agents',
    name: 'terrainAgents',
    component: SimpleRouteWrapper,
    meta: {
      label: 'Agents',
      group: true,
      roles: [ROLE_MANAGER],
      mode: ['terrain']
    },
    redirect: { name: 'terrainAgentsList' },
    children: [
      {
        path: 'list',
        name: 'terrainAgentsList',
        component: AgentsAnnuaire,
        meta: {
          label: 'Annuaire',
          icon: 'fa fa-address-book'
        }
      }
    ]
  },
  {
    path: 'terrain/badges',
    name: 'terrainBadges',
    component: SimpleRouteWrapper,
    meta: {
      label: 'Badges',
      group: true,
      roles: [ROLE_MANAGER],
      mode: ['terrain']
    },
    redirect: { name: 'terrainBadgesRead' },
    children: [
      {
        path: 'read',
        name: 'terrainBadgesRead',
        component: Nfc,
        meta: {
          label: 'Lire',
          icon: 'fa fa-qrcode'
        }
      }
    ]
  }
]
